export const FEATURE_FLAG_SHARE_MEETING_RECORDINGS = 'ADMIN_ShareMeetingRecordings';
export const FEATURE_FLAG_DASH_CALENDAR = 'ADMIN_DashCalendar' ;
export const FEATURE_FLAG_DIRECTORY_HIDING = 'ADMIN_DirectoryHiding';
export const FEATURE_FLAG_MULTI_PHONE = 'ADMIN_MultiPhone';
export const FEATURE_FLAG_MEETING_INVITES = 'ADMIN_MeetingInvites';
export const FEATURE_FLAG_THIRD_PARTY_BUTTONS = 'ADMIN_ThirdPartyButtons';
export const FEATURE_FLAG_ENABLE_PAST_MEETINGS = 'ADMIN_EnablePastMeetings';
export const FEATURE_FLAG_ENABLE_LIVE_MEETINGS = 'ADMIN_EnableLiveMeetings';
export const FEATURE_FLAG_CONNECT_TABLET_TO_ICON = 'ADMIN_ConnectTabletToIcon';
export const FEATURE_FLAG_ROOM_SYSTEM_MAINTENANCE_TAB = 'ADMIN_RoomSystemMaintenanceTab';
export const FEATURE_FLAG_GEO_DISTRIBUTION = 'ADMIN_GeoDistribution';
export const FEATURE_FLAG_ROOM_SYSTEM_REBOOT = 'ADMIN_RoomSystemReboot';
export const FEATURE_FLAG_ROOM_SYSTEM_RESET = 'ADMIN_RoomSystemReset';
export const FEATURE_FLAG_ROOM_SYSTEM_UPGRADE_MANAGEMENT = 'ADMIN_RoomSystemUpgradeManagement';
export const FEATURE_FLAG_UPLOAD_RECORDING = 'ADMIN_UploadRecording';
export const FEATURE_FLAG_ALEXA_INTEGRATION = 'ADMIN_AlexaIntegration';
export const FEATURE_FLAG_IMPERSONATION = 'ADMIN_Impersonation';
